const toParams = (hash) => {
  return Object.keys(hash).map((key) => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(hash[key])
  }).join('&');
}

export default toParams
